// CardHeader.tsx

import { Box, Stack, Typography } from '@mui/material'
import React, { PropsWithChildren } from 'react'

import TooltipIcon from '../../TooltipIcon'

export interface ICardHeaderProps {
  title?: string
  tooltip?: string
}

export default function CardHeader({ title, tooltip, children }: PropsWithChildren<ICardHeaderProps>) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '80px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: 'solid 1px',
        borderBottomColor: 'divider',
        p: '12px',
        boxSizing: 'border-box',
      }}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="h5">{title}</Typography>
        {tooltip && <TooltipIcon tooltip={tooltip} />}
      </Stack>
      <Box>{children}</Box>
    </Box>
  )
}
